import React, { useEffect, useState } from "react";
import { Table, Button, ButtonGroup } from "reactstrap";

import { ApiFund } from "../ApiFund";
import SearchFunds from "./SearchReport";
import {
  GetLanguageString,
  NoResult,
  SetReportTitle,
} from "../../helper/Components";
import {
  GetCustomStyles,
  GetSelectedLanguage,
  SelectOnlyDate,
} from "../../helper/Method";
import { CheckPermission, LoadingSpinner } from "../../../constants/const";
import { encryptStorage } from "../../../constants/EncryptStorage";
import { FcPrint } from "react-icons/fc";
import { RxCross2 } from "react-icons/rx";
import { ShowToast } from "../../shared/ShowToast";
import { useTranslation } from "react-i18next";
import { saveAs } from "file-saver";

import { toast, ToastContainer } from "react-toastify";
import { RiFileExcel2Line, RiFilePdf2Line } from "react-icons/ri";

const FundsReport = ({
  embedded = false,
  isActive = true,
  values: externalValues,
  cumulativeFund: externalCumulativeFund,
  memberFundsDetails: externalMemberFundsDetails,
  loading: externalLoading,
  searchTriggered: externalSearchTriggered,
}) => {
  const showAmount = CheckPermission("CanViewInfaqAmount");
  const [loading, setLoading] = useState(false);
  const loggedInUnitId = parseInt(encryptStorage.getItem("loggedInUnitId"));
  const [searchButton, setSearchButton] = useState(false);
  const [cumulativeFund, setCumulativeFund] = useState({
    totalMembers: 0,
    monthModels: [],
  });
  const { t } = useTranslation();
  const [memberFundsDetails, setMemberFundsDetails] = useState([]);
  let tempDate = new Date();
  tempDate.setDate(1);
  const [values, setValues] = useState({
    unit: { value: loggedInUnitId, lable: "" },
    isSubUnits: true,
    displayMemberDetails: true,
    startDate: SelectOnlyDate(tempDate),
    excludeExUnit: true,
    endDate: SelectOnlyDate(new Date()),
    showAmount: false,
    memberTypeIds: [],
  });
  const [reportTitle, setReportTitle] = useState("");
  const [modal, setModal] = useState(false);

  const activeValues = embedded ? externalValues : values;
  const activeCumulativeFund = embedded
    ? externalCumulativeFund
    : cumulativeFund;
  const activeMemberFundsDetails = embedded
    ? externalMemberFundsDetails
    : memberFundsDetails;
  const activeLoading = embedded ? externalLoading : loading;
  const activeSearchTriggered = embedded ? externalSearchTriggered : searchButton;

  useEffect(() => {
    if (!embedded && searchButton) {
      setLoading(true);
      ApiFund()
        .getMembersFundsDetails(values)
        .then((res) => {
          setCumulativeFund(res.data);
          setMemberFundsDetails(res.data.memberFundsDetails);
          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    }
  }, [values, searchButton, embedded]);

  useEffect(() => {
    if (reportTitle !== "") window.print();
  }, [reportTitle]);

  const handleReportTitle = () => {
    setModal(true);
  };

  const downloadExcel = () => {
    if (activeSearchTriggered) {
      const toastId = toast.loading(t("downloading_excel"));

      ApiFund()
        .GetMembersFundsDetailsExcelReport(activeValues)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "RafiqWiseInfaqReport.xlsx");
          ShowToast(toastId, "downloaded_excel", "success");
        })
        .catch((err) => {
          ShowToast(toastId, "Failed to download PDF.", "error");
          console.log(err);
        });
    }
  };
  const downloadPdf = () => {
    if (activeSearchTriggered) {
      const toastId = toast.loading(t("downloading_pdf"));
      ApiFund()
        .GetMembersFundsDetailsPdfReport(activeValues)
        .then((res) => {
          const blob = new Blob([res.data], {
            type: "application/pdf",
          });
          saveAs(blob, "RafiqWiseInfaqReport.pdf");
          ShowToast(toastId, "downloaded_pdf", "success");
        })
        .catch((err) => {
          ShowToast(toastId, "Failed to download PDF.", "error");
          console.log(err);
        });
    }
  };

  const showExportButtons =
    embedded ||
    activeCumulativeFund.totalMembers !== 0;

  const exportButtons = showExportButtons ? (
    <ButtonGroup className={GetCustomStyles().btn_style}>
      <Button
        color="default"
        size="sm"
        onClick={downloadExcel}
        style={{ marginRight: 3, marginBottom: 1 }}
      >
        <RiFileExcel2Line
          size={15}
          color="#009440"
          style={{ marginRight: 3, marginBottom: 1 }}
        />
        {<GetLanguageString props="member_report_export_excel" />}
      </Button>
      <Button color="default" size="sm" onClick={downloadPdf}>
        <RiFilePdf2Line
          size={15}
          color="#FF0000"
          className={GetCustomStyles().fa_style}
        />
        {<GetLanguageString props="member_report_export_pdf" />}
      </Button>
      <Button
        color="default"
        size="sm"
        onClick={handleReportTitle}
        style={{ marginRight: 3, marginBottom: 1 }}
      >
        <FcPrint size={15} className={GetCustomStyles().fa_style} />
        {<GetLanguageString props="common_print" />}
      </Button>
    </ButtonGroup>
  ) : null;

  const content = (
    <>
      {modal ? (
        <SetReportTitle setModal={setModal} setReportTitle={setReportTitle} />
      ) : null}
      <div id={isActive ? "section-to-print" : undefined}>
        {!embedded ? (
          <ToastContainer
            autoClose={3000}
            bodyClassName={GetSelectedLanguage()}
            closeOnClick
            pauseOnHover={false}
            draggable
          />
        ) : null}
        {!embedded ? (
          <div className="ibox noprint">
            <div className="ibox-title">
              <h5>{<GetLanguageString props="funds_report_search_fund" />} </h5>
            </div>
            <SearchFunds
              fundsValues={values}
              setFundsValues={setValues}
              setSearchButton={setSearchButton}
              showAmount={showAmount}
            />
          </div>
        ) : null}
        {!activeLoading ? (
          <>
            {(embedded || activeValues.displayMemberDetails) &&
            activeSearchTriggered ? (
              <div className="ibox ">
                <div className="ibox-title">{exportButtons}</div>
                <div className="ibox-content">
                  <>
                    {activeMemberFundsDetails?.length !== 0 ? (
                      <div className="table-responsive">
                        <Table className="table-stripped table-bordered footable">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>
                                {<GetLanguageString props="common_name" />}
                              </th>
                              <th>
                                {
                                  <GetLanguageString props="member_reg_number" />
                                }
                              </th>
                              <th>
                                {
                                  <GetLanguageString props="settings_member_type" />
                                }
                              </th>
                              <th>
                                {<GetLanguageString props="unit_unit_table" />}
                              </th>
                              {activeCumulativeFund.monthModels.map(
                                (record1, monthIndex) => {
                                  return (
                                    <th
                                      className="text-center"
                                      key={monthIndex}
                                    >
                                      {record1.monthName + " " + record1.year}
                                    </th>
                                  );
                                }
                              )}
                            </tr>
                          </thead>
                          <tbody>
                            {activeMemberFundsDetails?.map((record, index) => {
                              let unitName = record.unitName?.split("/");
                              return (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td className="ur">{record.name}</td>
                                  <td style={{ color: record.memberTypeColor }}>
                                    {record.regNo}
                                  </td>
                                  <td className="ur">{record.memberType}</td>
                                  <td className="ur">
                                    <ol className="breadcrumb">
                                      {unitName?.map((item, unitIndex) => {
                                        return (
                                          <li
                                            className={
                                              GetSelectedLanguage() === "ur"
                                                ? "breadcrumb-item-ur"
                                                : "breadcrumb-item"
                                            }
                                            key={unitIndex}
                                          >
                                            <span>{item}</span>
                                          </li>
                                        );
                                      })}
                                    </ol>
                                  </td>
                                  {record.monthsStatus.map(
                                    (record1, statusIndex) => {
                                      return (
                                        <td
                                          className="text-center"
                                          key={statusIndex}
                                        >
                                          {record1.status ? (
                                            showAmount &&
                                            activeValues.showAmount ? (
                                              <ol className="breadcrumb text-center">
                                                <li
                                                  className={
                                                    GetSelectedLanguage() ===
                                                    "ur"
                                                      ? "breadcrumb-item-ur"
                                                      : "breadcrumb-item"
                                                  }
                                                >
                                                  <span>
                                                    RS {record1.infaqAmount}
                                                  </span>
                                                </li>
                                                <li
                                                  className={
                                                    GetSelectedLanguage() ===
                                                    "ur"
                                                      ? "breadcrumb-item-ur"
                                                      : "breadcrumb-item"
                                                  }
                                                >
                                                  <span>
                                                    RCPT-{record1.receiptNumber}
                                                  </span>
                                                </li>
                                              </ol>
                                            ) : (
                                              <span className="text-center">
                                                RCPT-{record1.receiptNumber}
                                              </span>
                                            )
                                          ) : (
                                            <RxCross2
                                              size={18}
                                              color="red"
                                              style={{
                                                marginRight: 3,
                                                marginBottom: 1,
                                              }}
                                            />
                                          )}
                                        </td>
                                      );
                                    }
                                  )}
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <NoResult />
                    )}
                  </>
                </div>
              </div>
            ) : null}
          </>
        ) : (
          LoadingSpinner()
        )}
      </div>
    </>
  );

  if (embedded) {
    return content;
  }

  return (
    <div className="wrapper-custom wrapper wrapper-content animated fadeInRight">
      {content}
    </div>
  );
};

export default FundsReport;
